import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './my-booking.actions';
import { MyBookingState } from './my-booking.state';

/**
 * myBooking initial state
 */
export const myBookingInitialState: MyBookingState = {
  model: null,
};

/**
 * List of basic actions for MyBooking Store
 */
export const myBookingReducerFeatures: ReducerTypes<MyBookingState, ActionCreator[]>[] = [
  on(actions.setMyBooking, (_state, payload) => ({ ...payload })),

  on(actions.updateMyBooking, (state, payload) => ({ ...state, ...payload })),
];

/**
 * MyBooking Store reducer
 */
export const myBookingReducer = createReducer(myBookingInitialState, ...myBookingReducerFeatures);
